// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"bcdd2ab7","990":"e237c2b6"}[chunkId] + ".chunk.js";
};